// The canvas loads with React Flow on the pages that show it, not with every page.
import { type ComponentProps, lazy, Suspense } from "react";

import type { WorkflowPlayer as Player } from "./WorkflowPlayer";

const Lazy = lazy(() => import("./WorkflowPlayer").then((m) => ({ default: m.WorkflowPlayer })));

export function WorkflowPlayer(props: ComponentProps<typeof Player>) {
  return (
    <Suspense fallback={<div className={props.className} aria-busy />}>
      <Lazy {...props} />
    </Suspense>
  );
}
